import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemListItemEntity } from './item-list-item.entity';
import type { ItemListRoleEntity } from './item-list-role.entity';
import { UserEntity } from './user.entity';

export type ItemListVisibility = 'private' | 'role' | 'organization';

/**
 * A hand-picked, named set of items (PD-15839) — the item counterpart of
 * ClientListEntity. Same sharing model: private to the manager, shared with
 * specific roles, or visible to the whole organization, with an opt-in that
 * lets viewers add and remove members. Column names follow the current
 * (no underscore prefix) convention rather than the legacy client_list ones.
 */
@Index('idx_item_list_deleted', ['deletedDate'], {})
@Index('idx_item_list_visibility', ['visibility'])
@Index('idx_item_list_manager', ['managerUserId'])
@Entity('item_list')
export class ItemListEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('enum', {
		name: 'visibility',
		enum: ['private', 'role', 'organization'],
		default: 'private',
	})
	public visibility!: ItemListVisibility;

	@Column('int', {
		name: 'fk_user__id_manager',
		unsigned: true,
		nullable: true,
	})
	public managerUserId!: number | null;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id_manager', referencedColumnName: 'id' }])
	public manager!: UserEntity | null;

	@Column({ type: 'boolean', name: 'allowEdit', width: 1, default: () => "'0'" })
	public allowEdit!: boolean;

	@OneToMany(() => ItemListItemEntity, (member) => member.itemList, {})
	public itemListItems!: Array<ItemListItemEntity>;

	@OneToMany('ItemListRoleEntity', (role: ItemListRoleEntity) => role.itemList)
	public sharedRoles!: Array<ItemListRoleEntity>;
}
